<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div class="bg-white w-full lg:max-w-screen-lg mx-auto rounded-lg shadow-xl z-50 overflow-y-auto">
    <div class="flex justify-end">
      <button class="text-cerise-red">X</button>
    </div>
    <div class="flex flex-col">
      <h3>{{consulta.employee?.name}}</h3>
      <span>{{consulta.appointmentDate}}</span>

      <div class="flex">
        <img [src]="icon"/>
        <span>tipo</span>
      </div>

      <div class="flex justify-between">
        <div class="flex flex-col">
          <button>Remarcar</button>
          <button>Paciante não compareceu</button>
          <button>Ver histórico</button>
        </div>
        <button>Entrar</button>
      </div>
    </div>
  </div>
</div>
